import script from "./SnakeGame.vue?vue&type=script&setup=true&lang=js"
export * from "./SnakeGame.vue?vue&type=script&setup=true&lang=js"

import "./SnakeGame.vue?vue&type=style&index=0&id=05a2b0f6&scoped=true&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a2b0f6"]])

export default __exports__